export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 text-center mb-3">
          关于我们
        </h2>
        <p className="text-sm text-foreground-400 text-center mb-10 md:mb-14">
          了解黑料入口的故事与使命
        </p>
        <div className="bg-background-50 border border-background-200/60 rounded-lg p-6 md:p-10">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-start">
            <div className="flex-1">
              <p className="text-sm md:text-base text-foreground-300 leading-relaxed mb-4">
                黑料入口创立于对信息透明的执着追求。在这个信息爆炸的时代，各类黑料事件层出不穷，但碎片化的传播方式让读者难以看清全貌。我们致力于打造一个专业的黑料故事聚合平台，以时间线和专题的形式梳理每一起事件的来龙去脉，让吃瓜不再只是看热闹，而是真正理解黑料背后的真相脉络。
              </p>
              <p className="text-sm md:text-base text-foreground-300 leading-relaxed mb-4">
                我们的编辑团队由资深媒体人和行业观察者组成，覆盖娱乐圈、互联网、财经、体育等多个领域。每一篇黑料故事都经过多方核实和深度整理，确保信息来源可追溯、内容完整不偏颇。
              </p>
              <p className="text-sm md:text-base text-foreground-300 leading-relaxed">
                从黑料吃瓜网站到吃瓜黑料网站，黑料入口始终坚持以读者为中心，提供一站式的黑料浏览体验。我们相信，真正的吃瓜乐趣在于了解事件的全貌——这也是黑料网网址与黑料官网入口存在的意义。
              </p>
            </div>
            <div className="flex-shrink-0 w-full lg:w-[280px] space-y-4">
              <div className="flex items-center gap-3 p-4 bg-background-100 rounded-lg border border-background-200/60">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/15">
                  <i className="ri-shield-check-line text-lg text-primary-400"></i>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-200">多方核实</p>
                  <p className="text-xs text-foreground-500">信息来源可追溯</p>
                </div>
              </div>
              <div className="flex items-center gap-3 p-4 bg-background-100 rounded-lg border border-background-200/60">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500/15">
                  <i className="ri-time-line text-lg text-accent-400"></i>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-200">每日更新</p>
                  <p className="text-xs text-foreground-500">全天候追踪热点</p>
                </div>
              </div>
              <div className="flex items-center gap-3 p-4 bg-background-100 rounded-lg border border-background-200/60">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/15">
                  <i className="ri-stack-line text-lg text-primary-400"></i>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-200">12大分类</p>
                  <p className="text-xs text-foreground-500">全面覆盖黑料领域</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}